<!-- Popup thông tin nhà phát hành -->
<div class="modal-content">

  <!-- Modal Header -->
  <div class="modal-header">
    <div class="row">
      <div class="col-6">
        <label>{{'agent.name' | translate}}</label>
      </div>
      <div class="col-6">
        <label class="float-right">{{agent.shortName}}</label>
      </div>
    </div>
    <button type="button" class="close" (click)="cancel('agent-info')">
      <img title="Close" src="https://s3-ap-southeast-1.amazonaws.com/finanma-static/assets/images/icon/close.png">
    </button>
  </div>

  <!-- Modal body -->
  <div class="modal-body">
    <div class="row modal-row">
      <div class="col-12">
        <div class="row">
          <div class="col-4 col-sm-5 tt-buy-hgt">
            <label>{{'agent.full_name' | translate}}</label>
          </div>
          <div class="col-8 col-sm-7 text-right tt-buy-hgt">
            <label class="label-name">{{agent.name}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-4 col-sm-5 tt-buy-hgt">
            <label>{{'agent.address' | translate}}</label>
          </div>
          <div class="col-8 col-sm-7 text-right tt-buy-hgt">
            <label class="label-name">{{agent.address || agent.address1}}</label>
          </div>
        </div>
        <!-- Khong show thong tin mail vs sdt  -->
        <div class="row">
          <div class="col-4 col-sm-5 tt-buy-hgt">
            <label>{{'agent.phone' | translate}}</label>
          </div>
          <div class="col-8 col-sm-7 text-right tt-buy-hgt">
            <label class="label-name down">{{agent.phone}}</label>
          </div>
        </div>

        <div class="row">
          <div class="col-4 col-sm-5 tt-buy-hgt">
            <label>{{'agent.email' | translate}}</label>
          </div>
          <div class="col-8 col-sm-7 text-right tt-buy-hgt">
            <label class="label-name">{{agent.email}}</label>
          </div>
        </div>

        <div class="row">
          <div class="col-5 col-sm-5 tt-buy-hgt">
            <label>{{'agent.website' | translate}}</label>
          </div>
          <div class="col-7 col-sm-7 text-right tt-buy-hgt">
            <label class="label-name text-wrap"><a href="{{agent.website}}" target="_blank">{{agent.website}}</a></label>
          </div>
        </div>
        <div class="row">
          <div class="col-5 col-sm-5 tt-buy-hgt">
            <label>Chat với tổ chức</label>
          </div>
          <div class="col-7 col-sm-7 text-right tt-buy-hgt social row" >
            <a [href]="sanitize(item.sanitize)" *ngFor="let item of agent.userSocials"
              target="_blank">
              <img src="{{item?.socialTypeInfo?.icon}}" height="30">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  